// pages/Home.js
import React, { useEffect } from 'react';
import HeroSection from '../components/HeroSection';
import CountdownTimer from '../components/CountdownTimer';
import AboutSection from '../components/AboutSection';
import VideoSection from '../components/VideoSection';
import ScheduleSection from '../components/ScheduleSection';
import Separator from '../components/Separator';
import Carousel from '../components/Carousel';
import Contact from '../components/Contact';


import CountdownTimerAMZ from '../components/CountdownTimerAMZ';
import AboutSectionAMZ from '../components/AboutSectionAMZ';
import VideoSectionAMZ from '../components/VideoSectionAMZ';
import ContactAMZ from '../components/ContactAMZ';

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="home-page">
      <HeroSection />


    <Carousel />

      <AboutSectionAMZ />
      <Separator />
      <VideoSectionAMZ />
      <ContactAMZ />
      <Carousel />

    </div>
  );
}

export default Home;
